var $d26a615b0d5ff4d0$exports = {};
console.log("goni nas czas");
setTimeout(()=>{
    console.log("czas minął");
}, 5000);
console.log("czas dalej goni");
const $d26a615b0d5ff4d0$var$myInteval = setInterval(()=>{
    console.log("tik-tak");
}, 1000);
setTimeout(()=>{
    clearTimeout($d26a615b0d5ff4d0$var$myInteval);
}, 5000);


//# sourceMappingURL=index.e58583db.js.map
